import React, { useState } from 'react'
import { ArrowSquareUp, PlayCircle } from '@phosphor-icons/react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import API from '../../../api/api'
import SuccessConfirmationModal from '../../Popups/SuccessConfirmationModal'
import { useSnackbar } from '../../../helpers/hooks/useSnackbar'
import VideoPreviewModal from '../../VideoPreviewModal/VideoPreviewModal'

const Upsell = ({ buildingId }) => {
  const { t } = useTranslation(['organisation'])
  const [isConfirmationVisible, setIsConfirmationVisible] = useState(false)
  const [isVideoModalVisible, setIsVideoModalVisible] = useState(false)
  const { displaySnackbar } = useSnackbar()
  const [isLoading, setLoading] = useState(false)

  const handleSendEmail = async () => {
    try {
      setLoading(true)
      await API.sendUpsellingMessage({ type: 'reputationManagement' }, buildingId)
      setIsConfirmationVisible(true)
    } catch {
      displaySnackbar(t('organisation:reputationManagement.upsell.errors.sendFailed'), true)
    } finally {
      setLoading(false)
    }
  }

  const handlePlayVideo = () => {
    setIsVideoModalVisible(true)
  }

  const handleCloseVideo = () => {
    setIsVideoModalVisible(false)
  }

  return (
    <React.Fragment>
      <div className="reputation-management-page__upsell">
        <div className="reputation-management-page__upsell--info">
          <div className="reputation-management-page__upsell--slogan">
            <ArrowSquareUp size={32} weight="fill" />
            {t('organisation:reputationManagement.upsell.slogan')}
          </div>
          <div className="reputation-management-page__upsell--title-wrap">
            <h1 className="reputation-management-page__upsell--title">
              {t('organisation:reputationManagement.upsell.title')}
            </h1>
            <p className="reputation-management-page__upsell--subtitle">
              {t('organisation:reputationManagement.upsell.subtitle')}
            </p>
          </div>
          <ul className="reputation-management-page__upsell--list">
            <li className="reputation-management-page__upsell--list-item">
              <strong>{t('organisation:reputationManagement.upsell.listItem1Lead')}</strong>{' '}
              {t('organisation:reputationManagement.upsell.listItem1Text')}
            </li>
            <li className="reputation-management-page__upsell--list-item">
              <strong>{t('organisation:reputationManagement.upsell.listItem2Lead')}</strong>{' '}
              {t('organisation:reputationManagement.upsell.listItem2Text')}
            </li>
            <li className="reputation-management-page__upsell--list-item">
              <strong>{t('organisation:reputationManagement.upsell.listItem3Lead')}</strong>{' '}
              {t('organisation:reputationManagement.upsell.listItem3Text')}
            </li>
          </ul>
          <button
            onClick={handleSendEmail}
            className={`button button-black reputation-management-page__upsell--btn ${
              isLoading ? 'is-loading' : ''
            }`}
          >
            {t('organisation:reputationManagement.upsell.talkToAccountManager')}
          </button>
        </div>
        <div className="not-connected__img reputation-management-page__upsell--img">
          <div className="reputation-management-page__upsell--backdrop" onClick={handlePlayVideo}>
            <PlayCircle size={80} weight="fill" />
            <p>{t('organisation:reputationManagement.upsell.sneakPeek')}</p>
          </div>
          <img
            src="/images/upselling/reputation-management.png"
            alt={t('organisation:reputationManagement.upsell.imageAlt')}
          />
        </div>
      </div>
      {isConfirmationVisible && (
        <SuccessConfirmationModal
          header={t('organisation:reputationManagement.upsell.confirmation.header')}
          description={t('organisation:reputationManagement.upsell.confirmation.description')}
          handleClose={() => setIsConfirmationVisible(false)}
        />
      )}
      {isVideoModalVisible && (
        <VideoPreviewModal
          handleCloseVideo={handleCloseVideo}
          videoUrl="https://app.elevatedliving.com/chitown-default/ReputationManagementSystem.mp4"
        />
      )}
    </React.Fragment>
  )
}

Upsell.propTypes = {
  buildingId: PropTypes.number,
}

export default Upsell
